import React from 'react';
import { ArrowRight, Moon, Sparkles } from 'lucide-react';
import { FACES } from '../mock';

export default function Faces({ onBookRide }) {
  return (
    <section className="bg-[#0f0f10] text-white py-24 md:py-32 relative overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <span className="text-[11px] font-semibold tracking-[0.18em] text-[#FFB37A]">EVERY DAY ON OUR ROADS</span>
          <h2 className="mt-3 text-[34px] md:text-[48px] font-semibold tracking-[-0.02em] leading-[1.05]">
            The faces of <span className="text-[#FF6A1A]">ON THE WAY</span>
          </h2>
          <p className="mt-4 text-[15px] md:text-[17px] text-white/65 leading-relaxed max-w-2xl">
            From bike taxis at dawn to autos winding home at night — meet the people who keep India moving.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {FACES.map((f) => {
            const Icon = f.icon;
            return (
              <article
                key={f.tag}
                className="group relative rounded-3xl overflow-hidden bg-[#161618] ring-1 ring-white/5 hover:ring-[#FF6A1A]/50 transition-[box-shadow,transform] duration-500 hover:-translate-y-1 cursor-pointer"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={f.img}
                    alt={f.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f10] via-[#0f0f10]/40 to-transparent" />
                  <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-black/55 backdrop-blur-md text-[10.5px] font-semibold tracking-[0.16em] text-white px-3 py-1.5 rounded-full border border-white/15">
                    <Icon size={12} />
                    {f.tag}
                  </div>
                </div>
                <div className="p-6 md:p-7">
                  <h3 className="text-[22px] font-semibold tracking-[-0.01em]">{f.title}</h3>
                  <p className="mt-2 text-[14px] text-white/60 leading-relaxed">{f.desc}</p>
                  <div className="mt-5 inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#FF6A1A] group-hover:gap-3 transition-all">
                    Learn more <ArrowRight size={14} />
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {/* Night rides banner */}
        <div className="mt-12 md:mt-16 rounded-3xl bg-[#161618] ring-1 ring-white/5 p-7 md:p-10 flex flex-col md:flex-row md:items-center justify-between gap-6 relative overflow-hidden">
          <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full bg-[#FF6A1A]/10 blur-3xl pointer-events-none" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.14em] text-[#FFB37A]">
              <Moon size={13} /> NIGHT RIDES · SAFE & SURGE-CAPPED
            </div>
            <h3 className="mt-3 text-[24px] md:text-[30px] font-semibold tracking-[-0.01em] max-w-xl">
              From midnight cravings to early-morning flights — we are on the way.
            </h3>
          </div>
          <button
            onClick={onBookRide}
            className="relative inline-flex items-center gap-2 bg-[#FF6A1A] hover:bg-[#ff5a05] text-white font-semibold rounded-full px-6 py-3.5 text-[14.5px] transition-colors flex-shrink-0"
          >
            <Sparkles size={16} /> Book a ride
          </button>
        </div>
      </div>
    </section>
  );
}
